<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.edit_ad_data") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <h2>
            {{ $t("PLACEHOLDERS.storeData") }}
          </h2>
          <base-select-input
            col="12"
            :optionsList="storeTypes"
            :placeholder="$t('PLACEHOLDERS.storeType')"
            v-model="storeType"
          />

          <div class="row" v-if="storeType?.value == 'external'">
            <base-image-upload-input
              col="12"
              identifier="admin_image"
              :placeholder="$t('PLACEHOLDERS.logo')"
              @selectImage="selectImage1"
              :preSelectedImage="data.logo.path"
            />
            <base-input
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.store_name')"
              v-model.trim="data.storeName"
              required
            />
            <base-input
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.website')"
              v-model.trim="data.website"
            />
            <base-input
              col="6"
              type="number"
              :placeholder="$t('PLACEHOLDERS.contactNum')"
              v-model.trim="data.contactNum"
              required
            />
          </div>
          <div v-if="storeType?.value == 'internal'">
            <base-select-input
              col="12"
              :optionsList="providers"
              :placeholder="$t('PLACEHOLDERS.stoerproviders')"
              v-model="provider"
            />
          </div>
          <h2>
            {{ $t("PLACEHOLDERS.offerData") }}
          </h2>
          <!-- Start:: Image Upload Input -->
          <div class="col-12">
            <div class="row align-items-center">
              <v-col col="12" sm="12" md="12">
                <UploadsPhotos
                  :urls="imgUrls"
                  multiple
                  @onFileSelect="onFileSelect"
                  @onFileRemove="onFileRemove"
                >
                  {{ $t("PLACEHOLDERS.AddImage") }}
                  <!-- {{ $t("PLACEHOLDERS.extendPhoto") }} -->
                  <!-- <span class="text-danger">*</span> -->
                </UploadsPhotos>
              </v-col>
            </div>
          </div>
          <!-- End:: Image Upload Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.offerTitle')"
            v-model.trim="data.offerTitle"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.offerTitleEn')"
            v-model.trim="data.offerTitleEn"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.offerDesc')"
            v-model.trim="data.offerDesc"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.offerDescEn')"
            v-model.trim="data.offerDescEn"
            required
          />
          <!-- End:: Name Input -->
          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.startDate')"
            v-model.trim="data.startDate"
          />
          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.endDate')"
            v-model.trim="data.endDate"
          />
          <!-- End:: Confirm Password Input -->

          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>

          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import UploadsPhotos from "../../../components/formInputs/UploadsPhotos.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "EditAdmin",
  components: {
    UploadsPhotos,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isWaitingRequest: false,
      // End:: Loader Control Data
      storeType: null,
      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        logo: {
          path: null,
          file: null,
        },
        storeName: null,
        website: null,
        contactNum: null,
        offerTitle: null,
        offerTitleEn: null,
        offerDesc: null,
        offerDescEn: null,
        startDate: null,
        endDate: null,
        areas: [],
        active: true,
      },
      additionalImages: [],
      imgUrls: [],
      imageId: [],
      allAreas: [],
      providers: [],
      provider: null,
      vendor_id: null,
      // End:: Data Collection To Send
    };
  },

  computed: {
    // Start:: Vuex Getters
    ...mapGetters({
      allRoles: "ApiGetsModule/allRoles",
    }),
    storeTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.inSystem"),
          value: "internal",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.Outdoor"),
          value: "external",
        },
      ];
    },
    // End:: Vuex Getters
  },

  methods: {
    // Start:: Vuex Actions
    ...mapActions({
      getRoles: "ApiGetsModule/getRoles",
    }),
    onFileSelect(files) {
      this.additionalImages = files;
    },
    async onFileRemove(index) {
      this.$delete(this.imgUrls, index);

      const imageId = this.imageId[index];

      try {
        await this.$axios({
          method: "GET",
          url: `delete-file/${imageId}`,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.deletedSuccessfully"));
        this.$delete(this.imgUrls, index);
      } catch (error) {
        this.isWaitingRequest = false;
        // Handle error as needed
        this.$message.error(error.response.data.message);
      }
    },
    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    selectImage1(selectedImage) {
      this.data.logo = selectedImage;
    },
    // End:: Vuex Actions
    async getVendors() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `vendors?is_active=1&page=0&limit=0`,
        });
        // console.log("Cities =>", res.data.data);
        this.providers = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // Start:: Get Data To Show
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `discount-platforms/${this.id}`,
        });

        this.storeType = {
          name:
            res.data.data.discount_platform?.type == "internal"
              ? this.$t("PLACEHOLDERS.inSystem")
              : this.$t("PLACEHOLDERS.Outdoor"),
          value: res.data.data.discount_platform?.type,
        };
        this.data.logo.path = res.data.data.discount_platform?.vendor.avatar;
        this.data.storeName = res.data.data.discount_platform?.vendor.name;
        this.data.website = res.data.data.discount_platform?.vendor.website;
        this.data.contactNum = res.data.data.discount_platform?.vendor.mobile;
        this.provider = res.data.data.discount_platform?.vendor;
        this.vendor_id = res.data.data.discount_platform?.vendor_id;
        this.imgUrls = res.data.data.discount_platform?.designs.map(
          (item) => item.url
        );
        this.imageId = res.data.data?.discount_platform?.designs.map(
          (item) => item.id
        );

        this.data.offerTitle = res.data.data.discount_platform?.name_ar;
        this.data.offerTitleEn = res.data.data.discount_platform?.name_en;
        this.data.offerDesc = res.data.data.discount_platform?.description_ar;
        this.data.offerDescEn = res.data.data.discount_platform?.description_en;
        this.data.active = res.data.data.discount_platform?.is_active;
        this.data.startDate = res.data.data.discount_platform?.from_date;
        this.data.endDate = res.data.data.discount_platform?.to_date;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // End:: Get Data To Show

    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    // End:: Select Upload Image

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      // if (!this.data.image.path) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.image"));
      //   return;
      // }
      // if (!this.data.name) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.name"));
      //   return;
      // } else if (!this.data.email) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.email"));
      //   return;
      // } else
      // if (!this.data.phone) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.phone"));
      //   return;
      // } else {
      this.submitForm();
      // return;
      // }
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      if (this.storeType.value == "internal") {
        if (this.provider?.id) {
          REQUEST_DATA.append("vendor_id", this.provider?.id);
        } else {
          REQUEST_DATA.append("vendor_id", this.vendor_id);
        }
      }

      if (this.storeType.value == "external") {
        if (this.data.storeName) {
          REQUEST_DATA.append("vendor_name", this.data.storeName);
        }
        if (this.data.logo.file) {
          REQUEST_DATA.append("vendor_logo", this.data.logo.file);
        }
        if (this.data.website) {
          REQUEST_DATA.append("website", this.data.website);
        }
        if (this.data.contactNum) {
          REQUEST_DATA.append("contact_number", this.data.contactNum);
        }
      }

      if (this.additionalImages && this.additionalImages.length > 0) {
        this.additionalImages.forEach((file, index) => {
          REQUEST_DATA.append(`images[${index}]`, file);
        });
      }
      if (this.data.offerTitle) {
        REQUEST_DATA.append("name[ar]", this.data.offerTitle);
      }
      if (this.data.offerTitleEn) {
        REQUEST_DATA.append("name[en]", this.data.offerTitleEn);
      }
      if (this.data.offerDesc) {
        REQUEST_DATA.append("description[ar]", this.data.offerDesc);
      }
      if (this.data.offerDescEn) {
        REQUEST_DATA.append("description[en]", this.data.offerDescEn);
      }

      REQUEST_DATA.append("is_active", +this.data.active);
      REQUEST_DATA.append("type", this.storeType?.value);

      if (this.data.startDate) {
        REQUEST_DATA.append("from_date", this.data.startDate);
      }
      if (this.data.endDate) {
        REQUEST_DATA.append("to_date", this.data.endDate);
      }

      REQUEST_DATA.append("_method", "PUT");
      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `discount-platforms/${this.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/discount_platforms/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  async created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    this.getVendors();
    // End:: Fire Methods
  },
};
</script>
